<template>
  <div class="page-bg page">
    <SubHeader :title="headerTitle"></SubHeader>

    <div class="main">
      <div class="page-content">
        <div class="from-wrap">
          <div class="set-wrap">
            <div class="set-title">姓名</div>
            <div class="set-info">
              <div class="set-input">
                <input
                  type="text"
                  value=""
                  placeholder="请输入您的姓名"
                  v-model="name"
                  :disabled="Number(this.userInfo.account.is_idcard) === 1"
                />
              </div>
            </div>
          </div>
          <div class="set-wrap">
            <div class="set-title">身份证号</div>
            <div class="set-info">
              <div class="set-input">
                <input
                  type="text"
                  value=""
                  placeholder="请输入您的证件号码"
                  v-model="idcard"
                  :disabled="Number(this.userInfo.account.is_idcard) === 1"
                />
              </div>
            </div>
          </div>
          <div class="set-tips">
            应国家法律法规要求，购买前请完成实名认证。实名认证完成后，您的提现账户将与此实名信息进行绑定，请知晓！
          </div>
          <div class="set-tips" style="font-size: 0.26rem; color: #ff0000">
            实名认证一经审核，非平台法定认可不可修改
          </div>
          <div class="set-btn2" v-if="Number(userInfo.account.is_idcard) !== 1">
            <van-button @click="submit()" :disabled="Number(userInfo.account.is_idcard) === 1" >保 存</van-button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>


<script>
import SubHeader from "../../../components/sub_header";

import Vue from "vue";
import { mapActions, mapState } from "vuex";
import { Dialog, Field, Toast,Button  } from "vant";

Vue.use(Dialog);
Vue.use(Field);
Vue.use(Toast);
Vue.use(Button);

export default {
  name: "user-profile",
  data() {
    return {
      name: "",
      idcard: "",
    };
  },
  components: {
    SubHeader,
    [Dialog.Component.name]: Dialog.Component,
  },

// -1
  created() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;
    
    if(Number(this.userInfo.account.is_idcard) === 1){

      

      // Dialog.alert({
      //   title: "提示",
      //   message: "您已认证成功！",
      //   className: "dialog-public footer-center",
      // }).then(() => {
      //   this.$router.go(-1);
      //   // on close
      // });

      this.getUserInfoFun();
      
      
    }


  },
  methods: {
    ...mapActions({
      'getUserInfo': "user/getUserInfo",
      'updateUserIdCard':'user/updateUserIdCard'
    }),

    getUserInfoFun(){
      
      let toastLoading = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
      });
      this.getUserInfo({
        success: (res) => {
          // console.log(res)
          toastLoading.clear();
          if (res.status == 1) {

            this.name = res.user.truename;
            this.idcard = res.user.idcard;
            
          } else {
            Toast(res.message);
          }
        },
      });
    },
    submit() {
      let that = this;
      
      if (!that.isLogin) {
        that.$router.push("/login");
        return false;
      }

      let regIdcard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      let name = this.name;
      let idcard = this.idcard;

      if (this.name.match(/^\s*$/)) {
        Toast("请输入姓名");
        return;
      }
      if (this.idcard.match(/^\s*$/)) {
        Toast("请输入身份证号");
        return;
      }
      if (!regIdcard.test(this.idcard)) {
        Toast("身份证格式错误");
        return false;
      }
      
      let toastLoading = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
      });
      this.updateUserIdCard({
        name,
        idcard,
        success: (res) => {
          toastLoading.clear();
          if (res.status == 1) {
            // Toast("操作成功");
            this.getUserInfoFun();
            Dialog.alert({
              title: "审核中",
              message: "录入成功，系统正在审核",
              className: "dialog-public footer-center",
            }).then(() => {

              this.$router.go(-1);
              // on close
            });
            
          } else {
            Toast(res.message);
          }
        },
      });


    },
  },
  computed: {
    ...mapState({      
      isLogin: (state) => state.user.isLogin,
      userInfo: (state) => state.user.userInfo,
    })
  },

  mounted() {},

  activated() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  background-size: cover;
  box-sizing: border-box;
  height: 100vh;
}

.main {
  width: 100%;
  box-sizing: border-box;
  height: calc(100vh - 1.45rem);
  position: relative;
}
.page-content {
  position: relative;
  overflow-y: auto;
  height: 100%;
}

.set-wrap {
  margin-bottom: 0.3rem;
  .set-title {
    font-size: 0.3rem;
    color: #333234;
    line-height: 1rem;
    padding: 0 0.55rem;
    font-weight: bold;
  }
  .set-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: url(../../../assets/images/user/set/bg.png) repeat-y left top;
    background-size: 100% auto;
    height: 0.8rem;
    padding: 0 0.68rem 0 0.55rem;

    .set-input {
      flex: 1;
      height: 100%;
      input {
        width: 100%;
        height: 100%;
        background: none;
        font-size: 0.3rem;
        color: #333234;
        &::-webkit-input-placeholder {
          color: #5c5c5c;
        }
      }
    }
  }
}

.set-btn {
  margin-top: 1rem;
}
.set-btn2 {
  margin-top: 1rem;
}

.set-tips {
  padding: 0.24rem 0.55rem;
  font-size: 0.24rem;
  color: #8c8c8c;
  text-align: center;
  line-height: 1.8;
}


</style>


